<section class="footer__area footer-bg" [class.box-m-15]="box_style">
  <div class="footer__top pt-100 pb-60">
    <div class="container">
      <div class="row">

        <div class="col-xl-6 col-lg-6 col-md-6 col-12">
          <div class="footer__widget mb-30">
            <div class="footer__widget-title">
              <h5>Contact information</h5>
            </div>
            <div class="footer__widget-content">
              <div class="footer__contact">
                <ul>
                  <li>
                    <div class="icon">
                      <i class="fal fa-map-marker-alt"></i>
                    </div>
                    <div class="text">
                      <span>Add: 62, KANAKNIDHI, TIMALIYAWAD ROAD, NANPURA,<br/>
                        Surat, Gujarat, 395001</span>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <i class="fal fa-envelope-open-text"></i>
                    </div>
                    <div class="text">
                      <span>Email: <a href="mailto:itwalatechnologies@gmail.com">itwalatechnologies@gmail.com</a></span>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <i class="fal fa-phone-alt"></i>
                    </div>
                    <div class="text">
                      <span>Phone Number: <a href="tel:09879962658">(+91) 98799 62658</a></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="footer__social f-center mt-2">
              <ul>
                <li *ngFor="let item of social_links">
                  <a [href]="item.link" target="_blank"><i [class]="item.icon"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-12">
          <div class="footer__widget mb-30">
            <div class="footer__widget-title mb-25">
              <h5>Customer Service</h5>
            </div>
            <div class="footer__widget-content">
              <div class="footer__links">
                <ul>
                  <li><a href="#">Shipping Policy</a></li>
                  <li><a href="#">Help & Contact Us</a></li>
                  <li><a href="#">Returns & Refunds</a></li>
                  <li><a href="#">Online Stores</a></li>
                  <li><a href="#">Terms & Conditions</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-12">
          <div class="footer__widget mb-30">
            <div class="footer__widget-title mb-25">
              <a routerLink="/home">
                <img src="/assets/img/logo/footer-logo.svg" alt="logo" class="footer-logo">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer__bottom">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <div class="footer__copyright text-center">
            <p>Copyright © 2024 <a routerLink="https://imitwala.com/">IT Wala</a> all rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
